import type { FaireProductEntity } from "../../entity_types/product";

export const p_6qcb4w6lan: FaireProductEntity = {
  token: "p_6qcb4w6lan",
  type: "product",
  name: "Balsam Fir \u2013 16oz Winter Holiday Scented Gift Jar Candle",
  brandName: "A Cheerful Giver",
  imageUrl:
    "https://cdn.faire.com/fastly/b7c79048334a163580f0fa6d656db5657af0b0acbfcd7b8de28e321fc5d0468a.jpeg",
  priceDollars: 9.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/01445ab68cd1e9a4c43add01029bc847f5348fd895c09179ee6120ce113642bd.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
